/*******************************************************************************
 * Copyright (c) 2022 THERAYTEK
 *
 * All rights reserved.
 *
 * Contributors:
 *   Amina Rais
 *
 *******************************************************************************/

import React from 'react'
import { connect } from 'react-redux'
import PropTypes from 'prop-types'
import { withStyles } from '@mui/styles'
import { Card, Grid, Typography } from '@mui/material'
import { CardContent } from '@material-ui/core'

const styles = theme => ({
    paper: {
        background: 'rgba(0, 0, 0, 0.5)',
    },
    typestyle: {
        lineHeight: '2.5em!important',
    },
    subtypestyle: {
        lineHeight: '2em!important',
    },
})

class TosPage extends React.Component {
    componentDidMount() {
        window.scrollTo(0, 0);

    }
    render() {
        const { classes } = this.props
        return (
            <>
                <Grid container spacing={4} style={{ marginTop: '50px' }}>
                    <Grid item xs={12} sm={12} md={3} />
                    <Grid item xs={12} sm={12} md={6}>

                        <Card>
                            <CardContent>
                                <Typography variant="h2" className={classes.typestyle}>
                                    <b> Terms of Service
                                    </b>
                                </Typography>
                                <Typography variant="h3" className={classes.subtypestyle}>
                                    Please read these terms of service carefully before using "theraytek.tn" website operated by theraytek.
                                </Typography>
                                <Typography variant="h2" className={classes.typestyle}>
                                    <b>
                                        Conditions of Use
                                    </b>
                                </Typography>

                                <Typography variant="h2" className={classes.typestyle}>
                                    <b>
                                        Privacy Policy
                                    </b>
                                </Typography>
                                <Typography variant="h3" className={classes.subtypestyle}>
                                    Before you continue using our website we advise you to read our privacy policy
                                    regarding our user data collection. It will help you better understand our practices.
                                </Typography>

                                <Typography variant="h2" className={classes.typestyle}>
                                    <b>
                                        Copyright
                                    </b>
                                </Typography>

                                <Typography variant="h2" className={classes.subtypestyle}>
                                    Content published on this website  is the property of theraytek and/or its content creators and protected by international copyright laws.
                                    The entire compilation of the content found on this website is the exclusive property of theraytek, with copyright authorship for this compilation by theraytek.

                                </Typography>
                                <Typography variant="h2" className={classes.typestyle}>
                                    <b>
                                        Communications
                                    </b>
                                </Typography>
                                <Typography variant="h3" className={classes.subtypestyle}>
                                    The entire communication with us is electronic.
                                    Every time you send us an email or visit our website, you are going to be communicating with us.
                                    You hereby consent to receive communications from us. If you subscribe to the news on our website,
                                    you are going to receive regular emails from us. We will continue to communicate with you by posting news
                                    and notices on our website and by sending you emails. You also agree that all notices, disclosures, agreements,
                                    and other communications we provide to you electronically meet the legal requirements that
                                    such communications be in writing.


                                </Typography>
                                <Typography variant="h2" className={classes.typestyle}>
                                    <b>
                                        Applicable Law
                                    </b>
                                </Typography>

                                <Typography variant="h2" className={classes.subtypestyle}>
                                    By visiting this website, you agree that the laws of the tunisia, without regard to principles of conflict laws,
                                    will govern these terms of service, or any dispute of any sort that might come between THERAYTEK and you, or its business partners and associates.



                                </Typography>
                                <Typography variant="h2" className={classes.typestyle}>
                                    <b>
                                        Disputes
                                    </b>
                                </Typography>


                                <Typography variant="h2" className={classes.subtypestyle}>
                                    Any dispute related in any way to your visit to this
                                    website  shall be
                                    arbitrated by state or federal court Tunisia and
                                    you consent to exclusive jurisdiction and venue of such courts.
                                </Typography>
                                <Typography variant="h2" className={classes.typestyle}>
                                    <b>
                                        Comments, Reviews, and Emails
                                    </b>
                                </Typography>
                                <Typography variant="h3" className={classes.subtypestyle}>
                                    Visitors may post content as long as it is not obscene, illegal,
                                    defamatory, threatening, infringing of intellectual property rights,
                                    invasive of privacy, or injurious in any other way to third parties.
                                    Content has to be free of software viruses, political campaigns,
                                    and commercial solicitation.

                                    We reserve all rights (but not the obligation) to remove and/or edit such content.
                                    When you post your content, you grant THERAYTEK non-exclusive, royalty-free and irrevocable right to use,
                                    reproduce, publish, modify such content throughout the world in any media.

                                </Typography>


                                <Typography variant="h2" className={classes.typestyle}>
                                    <b>
                                        License and Site Access
                                    </b>
                                </Typography>
                                <Typography variant="h3" className={classes.subtypestyle}>
                                    We grant you a limited license to access and make personal use of this website.
                                    You are not allowed to download or modify it. This may be done only with written consent from us.
                                </Typography>
                            </CardContent>
                        </Card>
                    </Grid>
                </Grid>




            </>
        )
    }
}

TosPage.propTypes = {
    classes: PropTypes.object.isRequired,
}

function mapStateToProps() {
    return {}
}

const styledTosPage = withStyles(styles)(TosPage)
const connectedTosPage = connect(mapStateToProps)(styledTosPage)
export { connectedTosPage as TosPage }
